// extracted by mini-css-extract-plugin
module.exports = {"layout":"theme-fg_layout__uaBQR","flower":"theme-fg_flower__qD_Z7","square":"theme-fg_square__gCHlp"};